import * as z from "zod";
import {
  wooCommerceIntegrationSchema,
  wooCommerceSettingsInputSchema,
} from "./shared";

export const updateWooCommerceIntegration = {
  name: "updateWooCommerceIntegration" as const,
  input: wooCommerceSettingsInputSchema,
  output: z.object({ integration: wooCommerceIntegrationSchema }),
};
